<div id="noworlaterJuncture" class="row">
  <div class="col-12 p-0">
    <div class="component-header __indicator">
      <h3 class="label m-0">{{ 'junctures.nowOrLater.header' | translate }}</h3>
    </div>
  </div>

  @if (!this.emailInputFlag) {
    <div>
      <div class="col-12 pt-5">
        <span class="info">{{ 'junctures.nowOrLater.info' | translate }}</span>
        <div class="buttons text-center mt-3">
          <button type="button" class="btn nowButton me-2" (click)="continueNow()">{{ 'junctures.nowOrLater.continueNow' | translate }}</button>
          <button type="button" class="btn laterButton ms-2" (click)="continueLater()">{{ 'junctures.nowOrLater.continueLater' | translate }}</button>
        </div>
      </div>
    </div>
  }

  @if (this.emailInputFlag) {
    <div>
      <form id="contactInfoForm" [formGroup]="contactInfoForm">
        <div class="col-12 pt-5">
          <label class="form-label" for="emailAddress">{{ 'junctures.nowOrLater.email' | translate }}</label>
          <input id="emailAddress" class="form-control" type="text" name="email-address" placeholder="E-mail cím" formControlName="_emailAddressInput" (ngModelChange)="emailValidation($event)" [ngClass]="{'required': (!_emailAddressInputIsValid && (this.contactInfoForm.value['_emailAddressInput'].length > 0) && validationStarted)}" required>
          <button type="button" class="btn savePersonButton ms-2" (click)="savePerson()">{{ 'common.ok' | translate }}</button>
          @if (validationStarted) {
            <div>
              @if (!_emailAddressInputIsValid && !(this.contactInfoForm.value['_emailAddressInput'].length > 0)) {
                <div class="feedback invalid-feedback">{{ 'junctures.nowOrLater.emailMissing' | translate }}</div>
              }
            </div>
          }
          <div>
            @if (_emailAddressInputIsValid) {
              <div class="feedback valid-feedback">{{ 'junctures.nowOrLater.ok' | translate }}</div>
            }
            @if (!_emailAddressInputIsValid && this.contactInfoForm.value['_emailAddressInput'].length > 0) {
              <div class="feedback invalid-feedback">{{ 'junctures.nowOrLater.emailInvalid' | translate }}</div>
            }
          </div>
        </div>
      </form>
    </div>
  }
</div>
